import _ from 'underscore';
import type { EntityObject, OverreactRequestShape, StoredEntity } from '../public-types';
import { RecordGroup } from './record-group';

export class Store<TEntity extends EntityObject = EntityObject> {
  preemptiveRecords: Map<OverreactRequestShape, Array<StoredEntity<TEntity>>>;
  recordGroups: Record<string, RecordGroup<TEntity>>;
  uniqueId: string;

  constructor(uniqueId?: string) {
    this.uniqueId = uniqueId || _.uniqueId('Overreact_store_');
    this.recordGroups = {};
    this.preemptiveRecords = new Map();
    this.getRecordGroup = this.getRecordGroup.bind(this);

    if (window.__OVERREACT_DEVTOOLS__) {
      window.__OVERREACT_DEVTOOLS__.store = this;
      window.__OVERREACT_DEVTOOLS__.getStore(this);
    }
  }

  getRecordGroup(modelName: string) {
    if (!this.recordGroups[modelName]) {
      this.recordGroups[modelName] = new RecordGroup<TEntity>({
        schemaType: modelName,
        store: this,
      });
    }
    return this.recordGroups[modelName];
  }

  addPreemptiveRecords(
    key: OverreactRequestShape,
    records: Array<StoredEntity<TEntity>>,
  ) {
    this.preemptiveRecords.set(key, records);
  }

  removePreemptiveRecords(key: OverreactRequestShape) {
    const records = this.preemptiveRecords.get(key);
    this.preemptiveRecords.delete(key);
    return records;
  }
}
